import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AttendanceRoutingModule } from './attendance-routing.module';
import { AttendanceComponent } from '../attendance/attendance.component';
import { StudenteditlistComponent } from './studenteditlist/studenteditlist.component';
import { ReasonlistComponent } from './reasonlist/reasonlist.component';
import { PopupsceduleComponent } from './popupscedule/popupscedule.component';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { PopupbatchesComponent } from './popupbatches/popupbatches.component';
import { PopupdrillComponent } from './popupdrill/popupdrill.component';
import { PopupstudentlistComponent } from './popupstudentlist/popupstudentlist.component';
import { PopupresonlistComponent } from './popupresonlist/popupresonlist.component';
import { PopupfeedbackComponent } from './popupfeedback/popupfeedback.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgxSpinnerModule } from "ngx-spinner";
import { FlatpickrModule } from 'angularx-flatpickr';
import { PopupcommonfeedbackComponent } from './popupcommonfeedback/popupcommonfeedback.component';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
@NgModule({
  declarations: [StudenteditlistComponent, ReasonlistComponent, PopupsceduleComponent, PopupbatchesComponent, PopupdrillComponent, PopupstudentlistComponent, PopupresonlistComponent, PopupfeedbackComponent, PopupcommonfeedbackComponent],
  imports: [
    MatDialogModule,
    CommonModule,
    AttendanceRoutingModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    Ng2SearchPipeModule,
    FormsModule,
    FlatpickrModule.forRoot()
  ]
})
export class AttendanceModule { }
